/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Analysis/view.blocks to change it.
import AnalysisSectionTitle from './AnalysisSectionTitle/index'
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Analysis({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/AnalysesTree/Analyses/Content/Analysis"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Analysis.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<AnalysisSectionTitle
  viewPath={`${viewPath}/AnalysisSectionTitle`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
{children}
</React.Fragment>)
}